module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo1.57020f83.png";